export default "__VITE_ASSET__BDRNUKRf__"